module.exports = __webpack_public_path__ + "static/tips-acf97615c0c5e21a06a276454eca94c1.png";